import React from "react";
import WarningIcon from "@mui/icons-material/ErrorOutline";
import SettingsIcon from "@mui/icons-material/Settings";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { NEW, IN_PROGRESS, SOLVED, WORK_DONE } from "../../functions/constants";

/**
 *
 * @param {*} status
 */
export const getProcessIconByProcessingState = (status) => {
  const baseProps = {
    style: {
      fontSize: "small",
    },
  };
  switch (status) {
    case NEW:
      return <WarningIcon {...baseProps} style={{ color: "#FF1B1C" }} />;
    // case ACCEPTED:
    //   return <ArrowIcon
    //     {...iconProps}
    //     style={{
    //       ...iconProps.style,
    //       color: blue[500]
    //     }}
    //   />;
    case IN_PROGRESS:
      return <SettingsIcon {...baseProps} style={{ color: "#FCA921" }} />;
    case WORK_DONE:
    case SOLVED:
      return <CheckCircleIcon {...baseProps} style={{ color: "#7FB800" }} />;
    default:
  }
};
